<template>
	<v-container fluid fill-height>
		<v-layout column justify-center align-center>
			<div class="full-width">
				<v-row>
					<v-col md="4">
						<div class="pa-0">
							<v-card outlined class="full-width">
								<v-list-item two-line>
									<v-list-item-content>
										<div class="d-flex justify-space-between align-center text-overline mb-6">
											Cliente
											<v-icon v-if="this.$vuetify.breakpoint.mdAndUp" large
												color="info">mdi-account-tie</v-icon>
										</div>
										<v-list-item-title class="text-h5">
											{{ resume.cliente }}
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-avatar v-if="this.$vuetify.breakpoint.smAndDown" tile size="80">
										<v-icon large color="info">mdi-account-tie</v-icon>
									</v-list-item-avatar>
								</v-list-item>
							</v-card>
						</div>
					</v-col>
					<v-col md="2">
						<div class="pa-0">
							<v-card outlined class="full-width">
								<v-list-item two-line>
									<v-list-item-content>
										<div class="d-flex justify-space-between align-center text-overline mb-6">
											A Receber
											<v-icon v-if="this.$vuetify.breakpoint.mdAndUp" large
												color="#FEB019">mdi-cash-fast</v-icon>
										</div>
										<v-list-item-title class="text-h5">
											R$ {{ resume.receber }}
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-avatar v-if="this.$vuetify.breakpoint.smAndDown" tile size="80">
										<v-icon large color="#FEB019">mdi-cash-fast</v-icon>
									</v-list-item-avatar>
								</v-list-item>
							</v-card>
						</div>
					</v-col>
					<v-col md="2">
						<div class="pa-0">
							<v-card outlined class="full-width">
								<v-list-item two-line>
									<v-list-item-content>
										<div class="d-flex justify-space-between align-center text-overline mb-6">
											Recebido
											<v-icon v-if="this.$vuetify.breakpoint.mdAndUp" large
												color="#23b480">mdi-cash-refund</v-icon>
										</div>
										<v-list-item-title class="text-h5">
											R$ {{ resume.recebido }}
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-avatar v-if="this.$vuetify.breakpoint.smAndDown" tile size="80">
										<v-icon large color="#23b480">mdi-cash-refund</v-icon>
									</v-list-item-avatar>
								</v-list-item>
							</v-card>
						</div>
					</v-col>
					<v-col md="2">
						<div class="pa-0">
							<v-card outlined class="full-width">
								<v-list-item two-line>
									<v-list-item-content>
										<div class="d-flex justify-space-between align-center text-overline mb-6">
											Saldo
											<v-icon v-if="this.$vuetify.breakpoint.mdAndUp" large
												color="#23b480">mdi-cash-multiple</v-icon>
										</div>
										<v-list-item-title class="text-h5">
											R$ {{ resume.saldo }}
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-avatar v-if="this.$vuetify.breakpoint.smAndDown" tile size="80">
										<v-icon large color="#23b480">mdi-cash-multiple</v-icon>
									</v-list-item-avatar>
								</v-list-item>
							</v-card>
						</div>
					</v-col>
					<v-col md="2">
						<div class="pa-0">
							<v-card outlined class="full-width">
								<v-list-item two-line>
									<v-list-item-content>
										<div class="d-flex justify-space-between align-center text-overline mb-6">
											Horas Executadas
											<v-icon v-if="this.$vuetify.breakpoint.mdAndUp" large
												color="info">mdi-calendar-clock</v-icon>
										</div>
										<v-list-item-title class="text-h5">
											{{ resume.horasExecutadas }}
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-avatar v-if="this.$vuetify.breakpoint.smAndDown" tile size="80">
										<v-icon large color="info">mdi-calendar-clock</v-icon>
									</v-list-item-avatar>
								</v-list-item>
							</v-card>
						</div>
					</v-col>
					<v-col cols="12">
						<div class="pa-0">
							<v-text-field outlined v-model="search" label="Buscar..." required
								class="field"></v-text-field>
						</div>
					</v-col>
				</v-row>
			</div>
			<v-row align-content="start" cols="12" class="full-width mb-2" fill-height
				:style="checkMobileScreen ? `display: block; height: ${(filteredDataset.length * 460) + 20}px` : ``">
				<v-col v-for="(x, i) in filteredDataset" :key="i" md="3"
					:style="!checkMobileScreen && 'height: 350px;'">
					<v-card v-if="x.tipoReg === 'Horas'" style="height: 100%;">
						<v-card-title style="height: 72px;">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<span class="subtitle-2 text-truncate" style="width: 380px;"
										:class="{ 'red--text': x.idStatus === 'I' }" v-bind="attrs" v-on="on">{{
											x.descricao
										}}</span>
								</template>
								<span class="subtitle-2" :class="{ 'red--text': x.idStatus === 'I' }">{{ x.descricao
								}}</span>
							</v-tooltip>

							<v-spacer></v-spacer>
							<v-icon :color="handleIcon(x.tipoReg).color">{{ handleIcon(x.tipoReg).icon }}</v-icon>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-row cols="12">
								<v-col md="12" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Resp.: {{ x.responsavel }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Resp.: {{ x.responsavel }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Ticket: {{ x.nTicket }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Ticket: {{ x.nTicket }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Horas: {{ x.qtdHoras }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Horas: {{ x.qtdHoras }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col xs="6" sm="6" md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Início: {{ x.dataInicio }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Início: {{ x.dataInicio }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col xs="6" sm="6" md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Fim: {{ x.dataFim }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Fim: {{ x.dataFim }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Monitorado: <v-icon color="green"
													v-if="x.monitorado === 1">mdi-eye-check-outline</v-icon> <v-icon
													v-else color="red">mdi-eye-remove-outline</v-icon>
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Monitorado: <v-icon color="green"
												v-if="x.monitorado === 1">mdi-eye-check-outline</v-icon>
											<v-icon v-else color="red">mdi-eye-remove-outline</v-icon>
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12" v-if="x.monitorado === 1">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Data Monit.: {{ x.dataMonitoramento }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Data Monit: {{ x.dataMonitoramento }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12" v-if="x.monitorado === 1">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Monit. ADM: <v-icon color="green"
													v-if="x.monitoradoAdm === 1">mdi-eye-check-outline</v-icon> <v-icon
													v-else color="red">mdi-eye-remove-outline</v-icon>
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Monitorado ADM: <v-icon color="green"
												v-if="x.monitoradoAdm === 1">mdi-eye-check-outline</v-icon>
											<v-icon v-else color="red">mdi-eye-remove-outline</v-icon>
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12" v-if="x.monitorado === 1 && x.monitoradoAdm === 1">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Data ADM: {{ x.dataMonitoramentoAdm }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Data Monit. ADM: {{ x.dataMonitoramentoAdm }}
										</div>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
					<v-card v-else style="height: 100%;">
						<v-card-title style="height: 72px;">
							<span class="subtitle-2" :class="{ 'red--text': x.idStatus === 'I' }">{{ x.tipoReg
							}}</span>
							<v-spacer></v-spacer>
							<v-icon :color="handleIcon(x.tipoReg).color">{{ handleIcon(x.tipoReg).icon }}</v-icon>
							<v-menu bottom left>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mx-2" fab dark small text color="primary" v-bind="attrs" v-on="on">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>
								<v-list dense>
									<v-list-item ripple @click="showModalNewEdit(x.id)" v-if="x.idStatus === 'A'">
										<v-list-item-icon>
											<v-icon color="primary">mdi-pencil</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Alterar</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item ripple @click="activeInactive(x.id)">
										<v-list-item-icon>
											<v-icon :color="x.idStatus === 'A' ? 'error' : 'positive'">{{ x.idStatus ===
												'A' ? 'mdi-trash-can-outline' :
												'mdi-check-all' }}</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>{{ x.idStatus === 'A' ? 'Inativar' : 'Reativar'
											}}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-row cols="12">
								<v-col md="12" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Ticket.: {{ x.nTicket }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Ticket.: {{ x.nTicket }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												{{ x.tipoReg === 'Parcela' ? 'Vencimento: ' : 'Data: ' }}{{ x.data }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											{{ x.tipoReg === 'Parcela' ? 'Vencimento: ' : 'Data: ' }}{{ x.data }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="6" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Valor: R$ {{ x.valor }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Valor: R$ {{ x.valor }}
										</div>
									</v-tooltip>
								</v-col>
								<v-col md="12" cols="12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
												Histórico: {{ x.historico }}
											</div>
										</template>
										<div class="font-weight-black text-truncate">
											Histórico: {{ x.historico }}
										</div>
									</v-tooltip>
								</v-col>
								<template v-if="x.tipoReg === 'Recebimento'">
									<v-col md="6" cols="12">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
													Monitorado: <v-icon color="green"
														v-if="x.monitorado === 1">mdi-eye-check-outline</v-icon> <v-icon
														v-else color="red">mdi-eye-remove-outline</v-icon>
												</div>
											</template>
											<div class="font-weight-black text-truncate">
												Monitorado: <v-icon color="green"
													v-if="x.monitorado === 1">mdi-eye-check-outline</v-icon>
												<v-icon v-else color="red">mdi-eye-remove-outline</v-icon>
											</div>
										</v-tooltip>
									</v-col>
									<v-col md="6" cols="12" v-if="x.monitorado === 1">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<div class="font-weight-black text-truncate" v-bind="attrs" v-on="on">
													Data Monit.: {{ x.dataMonitoramento }}
												</div>
											</template>
											<div class="font-weight-black text-truncate">
												Data Monit: {{ x.dataMonitoramento }}
											</div>
										</v-tooltip>
									</v-col>
								</template>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-speed-dial fab dark large color="primary" fixed right bottom v-model="fab" transtion="scale"
				direction="top" :top="false" :left="false" :open-on-hover="false">
				<template v-slot:activator>
					<v-btn v-model="fab" :color="fab ? 'red' : 'success'" fab>
						<v-icon v-if="fab">
							mdi-dots-horizontal
						</v-icon>
						<v-icon v-else>
							mdi-dots-vertical
						</v-icon>
					</v-btn>
				</template>
				<v-btn fab dark small color="indigo" @click="showModalNewEdit(null)">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<v-btn fab dark small color="green" @click="xlsxExport()">
					<v-icon>mdi-microsoft-excel</v-icon>
				</v-btn>
				<v-btn fab dark small color="orange" @click="showModalFiltrarLancamento()">
					<v-icon>mdi-filter</v-icon>
				</v-btn>
			</v-speed-dial>
		</v-layout>
		<ModalCrud v-if="modals.criarEditarLancamento.visible" :loading="modals.criarEditarLancamento.isLoading"
			:opened="modals.criarEditarLancamento.visible" :title="modals.criarEditarLancamento.title">
			<template v-slot:body>
				<v-form ref="form" v-model="forms.criarEditarLancamento.controls.isValid" lazy-validation>
					<div class="mt-5">
						<v-radio-group v-model="forms.criarEditarLancamento.data.tipo" row>
							<v-radio label="Parcela" value="P"></v-radio>
							<v-radio label="Recebimento" value="R"></v-radio>
						</v-radio-group>
					</div>
					<v-row cols="12">
						<v-col md="4">
							<v-text-field outlined v-model="forms.criarEditarLancamento.data.nTicket" label="Ticket"
								type="text">
							</v-text-field>
						</v-col>
						<v-col md="4">
							<v-text-field outlined v-model="forms.criarEditarLancamento.data.data"
								:rules="formsValidations.fieldRequired"
								:label="forms.criarEditarLancamento.data.tipo === 'P' ? 'Vencimento' : 'Data'"
								type="date" required class="field" />
						</v-col>
						<v-col md="4">
							<v-currency-field ref="refCurrencyField" label="Valor"
								:rules="formsValidations.valueRequired" outlined
								v-model="forms.criarEditarLancamento.data.valor" />
						</v-col>
					</v-row>
					<v-row cols="12">
						<v-col md="12">
							<v-text-field label="Histórico" type="text" outlined
								v-model="forms.criarEditarLancamento.data.historico" />
						</v-col>
					</v-row>
					<v-row v-if="forms.criarEditarLancamento.data.tipo === 'R' && ($store.state.infoUser.current.supervisor || $store.state.infoUser.current.departamento === 4)" cols="12" class="mt-0">
						<v-col md="6">
							<div style="margin-bottom: -15px;">Recebimento Monitorado</div>
							<v-radio-group v-model="forms.criarEditarLancamento.data.monitorado" row>
								<v-radio label="Sim" :value="1"></v-radio>
								<v-radio label="Não" :value="0"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col v-if="forms.criarEditarLancamento.data.monitorado" md="12" style="margin-top: -15px;">
							<v-text-field outlined v-model="forms.criarEditarLancamento.data.dataMonitoramento"
								:rules="formsValidations.fieldRequired" label="Data Monitoramento" type="date" required
								class="field" />
						</v-col>
					</v-row>
				</v-form>
			</template>
			<template v-slot:actions>
				<v-card-actions>
					<v-btn depressed color="success" @click="createUpdate()" class="button-width-large">
						<v-icon left>mdi-content-save-plus</v-icon>
						Confirmar
					</v-btn>
					<v-btn depressed color="error" class="button-width-large"
						@click="handleDestroyModals('createUpdate')">
						<v-icon left>mdi-cancel</v-icon>
						Cancelar
					</v-btn>
				</v-card-actions>
			</template>
		</ModalCrud>
		<ModalCrud :loading="modals.filtrarLancamentos.isLoading" :opened="modals.filtrarLancamentos.visible"
			:title="modals.filtrarLancamentos.title">
			<template v-slot:body>
				<v-form ref="form" v-model="forms.filtrarLancamentos.controls.isValid" lazy-validation>
					<v-row cols="12" class="mt-5">
						<v-col md="12">
							<div>
								<v-autocomplete outlined auto-select-first clearable
									v-model="forms.filtrarLancamentos.data.tipoRegistro"
									:items="forms.filtrarLancamentos.datasets.tipoRegistro" multiple
									label="Tipo de Lançamento" required />
							</div>
						</v-col>
					</v-row>
					<v-row cols="12">
						<v-col md="6">
							<v-text-field type="date" outlined v-model="forms.filtrarLancamentos.data.dataInicio"
								label="Data Inicial" required class="field" />
						</v-col>
						<v-col md="6">
							<v-text-field type="date" outlined v-model="forms.filtrarLancamentos.data.dataFim"
								label="Data Final" required class="field" />
						</v-col>
					</v-row>
				</v-form>
			</template>
			<template v-slot:actions>
				<v-card-actions>
					<v-btn depressed color="success" @click="loadData()" class="button-width-large">
						<v-icon left>mdi-content-save-plus</v-icon>
						Confirmar
					</v-btn>
					<v-btn depressed color="error" class="button-width-large" @click="handleDestroyModals('filter')">
						<v-icon left>mdi-cancel</v-icon>
						Cancelar
					</v-btn>
				</v-card-actions>
			</template>
		</ModalCrud>
	</v-container>
</template>

<script>
import api from '@/api/api';
import ModalCrud from '@/components/ModalCrud.vue';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { formsValidations } from '@/utils/formsValidations';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'ServicoControleHorasComissao',
	data() {
		return {
			search: '',
			isLoading: false,
			dataset: [],
			fab: false,
			resume: {
				cliente: '',
				horasExecutadas: '',
				receber: '',
				recebido: '',
				saldo: ''
			},
			modals: {
				criarEditarLancamento: {
					isLoading: false,
					visible: false,
					title: ''
				},
				filtrarLancamentos: {
					isLoading: false,
					visible: false,
					title: 'Filtrar'
				}
			},
			forms: {
				criarEditarLancamento: {
					data: {
						id: null,
						tipo: 'P',
						nTicket: '',
						data: '',
						valor: '',
						historico: '',
						idControleHoras: '',
						idStatus: 'A',
						monitorado: 0,
						dataMonitoramento: null
					},
					controls: {
						isValid: true
					}
				},
				filtrarLancamentos: {
					data: {
						tipoRegistro: [],
						dataInicio: null,
						dataFim: null,
						idControleHoras: null
					},
					datasets: {
						tipoRegistro: ['Horas', 'Parcela', 'Recebimento']
					},
					controls: {
						isValid: true
					}
				}
			}
		}
	},
	methods: {
		async loadData() {
			try {
				this.$store.state.loading = true;
				const { data } = await api.get('/service-time-control-comission', {
					params: {
						...this.forms.filtrarLancamentos.data,
						idControleHoras: this.$router.currentRoute.params.id
					}
				});
				this.dataset = data.serviceTimeControlComissions;
				this.resume = data.resume[0];
				this.handleDestroyModals('filter')
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.$store.state.loading = false;
			}
		},
		async showModalNewEdit(id) {
			try {
				this.$store.state.loading = true;
				this.modals.criarEditarLancamento.isLoading = true;
				this.modals.criarEditarLancamento.visible = true;
				this.modals.criarEditarLancamento.title = id ? `${id} - Editar Lançamento ` : 'Novo lançamento';

				if (id) {
					const { data } = await api.get(`/service-time-control-comission/${id}`);
					const { timeControlComission } = data;
					this.forms.criarEditarLancamento.data = {
						...timeControlComission
					};
				};
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.$store.state.loading = false;
				this.modals.criarEditarLancamento.isLoading = false;
			}
		},
		async activeInactive(id) {
			try {
				this.$store.state.loading = true;
				await api.patch(`/service-time-control-comission/${id}`);
				await this.loadData();
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.$store.state.loading = false;
			}
		},
		showModalFiltrarLancamento() {
			try {
				this.$store.state.loading = true;
				this.modals.filtrarLancamentos.isLoading = true;
				this.modals.filtrarLancamentos.visible = true;
				this.modals.filtrarLancamentos.title = 'Filtrar';
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.$store.state.loading = false;
				this.modals.filtrarLancamentos.isLoading = false;
			}
		},
		async createUpdate() {
			try {
				this.$store.state.loading = true;
				this.modals.criarEditarLancamento.isLoading = true;
				let formValidation = await this.$refs.form.validate();
				if (formValidation) {
					const [metodo, mensagem] = this.forms.criarEditarLancamento.data.id ? ['put', 'alterada'] : ['post', 'criada'];
					await api[metodo]('/service-time-control-comission', {
						...this.forms.criarEditarLancamento.data,
						nTicket: this.forms.criarEditarLancamento.data.nTicket ? this.forms.criarEditarLancamento.data.nTicket : '',
						dataMonitoramento: this.forms.criarEditarLancamento.data.monitorado ? this.forms.criarEditarLancamento.data.dataMonitoramento : null,
						idControleHoras: Number(this.$router.currentRoute.params.id)
					});
					this.$toast.success(`Movimentação ${mensagem} com sucesso!`);
					await this.loadData();
					this.handleDestroyModals('createUpdate')
				} else {
					throw new Error("Formulário inválido.")
				}
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.$store.state.loading = false;
				this.modals.criarEditarLancamento.isLoading = false;
			}
		},
		handleDestroyModals(modal) {
			switch (modal) {
				case 'createUpdate':
					this.modals.criarEditarLancamento.isLoading = false;
					this.modals.criarEditarLancamento.title = '';
					this.modals.criarEditarLancamento.visible = false;
					this.forms.criarEditarLancamento.data = {
						id: null,
						tipo: 'P',
						nTicket: '',
						data: '',
						valor: '',
						historico: '',
						idControleHoras: '',
						idStatus: 'A',
						monitorado: 0,
						dataMonitoramento: null
					}
					this.forms.criarEditarLancamento.controls.isValid = true;
					break;
				case 'filter':
					this.modals.filtrarLancamentos.isLoading = false;
					this.modals.filtrarLancamentos.title = 'Filtrar';
					this.modals.filtrarLancamentos.visible = false;
					break;
			}
		},
		handleIcon(tipoReg) {
			switch (tipoReg) {
				case 'Horas': {
					return {
						icon: 'mdi-calendar-clock',
						color: 'info'
					}
				};
				case 'Parcela': {
					return {
						icon: 'mdi-cash-fast',
						color: '#FEB019'
					}
				};
				case 'Recebimento': {
					return {
						icon: 'mdi-cash-refund',
						color: '#23b480'
					}
				};
			}
		},
		async xlsxExport() {
			try {
				const prepareData = this.filteredDataset.map(x => {
					return {
						nTicket: x.nTicket ? x.nTicket : '',
						qtdHoras: x.qtdHoras,
						descricao: x.descricao,
						dataInicio: x.dataInicio,
						dataFim: x.dataFim,
						data: x.data,
						valor: x.valor ? Number(x.valor.replaceAll('.', '#').replaceAll(',', '.').replaceAll('#', '')) : 0,
						responsavel: x.responsavel,
						historico: x.historico,
						monitorado: x.tipoReg === 'Parcela' ? 'N/A' : x.monitorado ? 'Sim' : 'Não',
						dataMonitoramento: x.dataMonitoramento,
						monitoradoAdm: x.tipoReg === 'Horas' ? (x.monitoradoAdm ? 'Sim' : 'Não') : 'N/A',
						dataMonitoramentoAdm: x.dataMonitoramentoAdm,
						idStatus: x.idStatus === 'A' ? 'Ativo' : 'Inativo'
					}
				});

				const { XlsxExport } = await import('@/utils/xlsxExport');

				let instanceExport = new XlsxExport({
					columns: [
						{
							name: 'nTicket',
							label: 'Ticket',
						},
						{
							name: 'qtdHoras',
							label: 'Horas',
							isHourMin: true,
						},
						{
							name: 'descricao',
							label: 'Descrição'
						},
						{
							name: 'dataInicio',
							label: 'Data Inicio',
							isDate: true,
						},
						{
							name: 'dataFim',
							label: 'Data Fim',
							isDate: true,
						},
						{
							name: 'data',
							label: 'Data Recebimento/Parcela',
							isDate: true,
						},
						{
							name: 'valor',
							label: 'Valor $$',
							isCurrency: true
						},
						{
							name: 'responsavel',
							label: 'Responsável'
						},
						{
							name: 'historico',
							label: 'Histórico'
						},
						{
							name: 'monitorado',
							label: 'Monitorado'
						},
						{
							name: 'dataMonitoramento',
							label: 'Data Monitoramento',
							isDate: true,
						},
						{
							name: 'monitoradoAdm',
							label: 'Monitorado ADM'
						},
						{
							name: 'dataMonitoramentoAdm',
							label: 'Data Monitoramento ADM',
							isDate: true,
						},
					],
					data: prepareData,
					title: `Registro de Comissões sob Serviço - ${this.$router.currentRoute.params.id}`
				});

				await instanceExport.export();
				instanceExport = null;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
	},
	computed: {
		checkMobileScreen() {
			const check = this.isMobile;
			return check;
		},
		filteredDataset() {
			let lowerSearch = this.search.toLowerCase();

			return this.dataset.filter(x => {
				return [
					x.nTicket,
					x.qtdHoras,
					x.descricao,
					x.dataInicio,
					x.dataFim,
					x.data,
					x.valor,
					x.responsavel,
					x.historico
				].map(field => (field || "").toLowerCase()).some(field => field.includes(lowerSearch));
			});
		}
	},
	components: {
		ModalCrud
	},
	async mounted() {
		store.commit(M_MENU, `Registro de Comissões sob Serviço - ${this.$router.currentRoute.params.id}`);
		await this.loadData();
	},
	setup() {
		return {
			formsValidations
		}
	}
})

</script>
